import 'leaflet/dist/leaflet.css';
import './styles/app.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App.js';
import { legacyHashToPath } from './lib/legacy-hash.js';

// Tautan lama v1 (https://shalmajaya.com/#/spo?tab=diajukan) → URL bersih (/spo?tab=diajukan).
const clean = legacyHashToPath(window.location.hash);
if (clean) window.history.replaceState(null, '', clean);

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root tidak ditemukan');
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
